'use strict';

require('./BoxSelector.scss');
const Router = require('react-router');
const {Navigation} = require('react-router');
const React = require('react');
const {PropTypes} = require('react');
const {Link} = Router;

const BoxSelector = React.createClass({displayName: "BoxSelector",

    mixins: [Navigation],

    propTypes: {
        title: PropTypes.string,
        imageSrc: PropTypes.string,
        style: PropTypes.object,
        link: PropTypes.string
    },

    render() {
        const {title, imageSrc, style, link} = this.props;
        return (
            React.createElement("a", {style: {textDecoration: 'none'}, href: link || ''}, 
                React.createElement("article", {className: "box-selector", style: style}, 
                    React.createElement("h1", {className: "box-selector__header"}, title), 
                    React.createElement("p", {className: "box-selector__body"}, 
                        React.createElement("img", {className: "box-selector__body-image", src: imageSrc})
                    )
                )
            )
        );
    }
});


module.exports = BoxSelector;



/** WEBPACK FOOTER **
 ** ./src/components/BoxSelector/BoxSelector.jsx
 **/